import { TextHelper } from 'src/app/utils/text-helper';
import { ActivatedRoute } from '@angular/router';
import { PersoanlService } from './../../../../data/repository/plan-repository/persoanl.service';
import {
  PersonalPackageFood,
  Perosnlapackages,
} from './../../../../core/model/api-response/persoanl-response-model';
import { AddFoodBottomsheetComponent } from './../../add-food-bottomsheet/add-food-bottomsheet.component';
import { EditFoodBottomsheetComponent } from './../../edit-food-bottomsheet/edit-food-bottomsheet.component';
import { CalorieCalculator } from './../../../../utils/calorie-calculator';
import { FoodModel } from './../../../../core/model/object/diet-food-model';
import { PersonalDataService } from './../../../../data/repository/plan-repository/personal-data.service';
import { PlanService } from 'src/app/data/repository/plan-repository/plan.service';
import { Component, OnInit } from '@angular/core';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { CreatePersonalPackageParams } from 'src/app/core/model/api-response/persoanl-response-model';
import { SnackBarService } from 'src/app/data/repository/utils-repository/snack-bar.service';

@Component({
  selector: 'app-create-personal-package',
  templateUrl: './create-personal-package.component.html',
  styleUrls: ['./create-personal-package.component.scss'],
})
export class CreatePersonalPackageComponent implements OnInit {
  packageTitle: string = null;
  foodFactsAmount: number[] = [
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
  ];

  foodFactsNames = [
    'کالری',
    'پروتئین',
    'کربوهیدرات',
    'چربی',
    'قند',
    'فیبر',
    'سدیم',
    'پتاسیم',
    'کلسیم',
    'منیزیم',
    'فسفر',
    'آهن',
    'اسید چرب اشباع',
    'اسید های چرب تک غیر اشباع',
    'اسیدهای چرب چند غیر اشباع',
    'اسید چرب ترانس',
    'کلسترول',
  ];
  foodFactsUnits = [
    'کالری',
    'گرم',
    'گرم',
    'گرم',
    'گرم',
    'گرم',
    'میلی گرم',
    'میلی گرم',
    'میلی گرم',
    'میلی گرم',
    'میلی گرم',
    'میلی گرم',
    'گرم',
    'گرم',
    'گرم',
    'گرم',
    'میلی گرم',
  ];
  ready: boolean = false;
  edit: boolean = false;
  show: boolean = false;
  displaySearch: boolean = false;
  selectdFoods: [FoodModel, number][] = [];
  editPersonalPAckage: Perosnlapackages = null;
  constructor(
    private planService: PlanService,
    private personalDataService: PersonalDataService,
    private calorieCalculator: CalorieCalculator,
    private matBottomSheet: MatBottomSheet,
    private persoanlService: PersoanlService,
    private snackBarService: SnackBarService,
    private route: ActivatedRoute,
    private textHelper: TextHelper
  ) {
    this.personalDataService.addPeronalpackage$.subscribe((d) => {
      if (d) {
        this.closeSearch();
        this.modifyFood(d);
        this.calculateFoodAmount();
        this.activeBtn();
      }
    });
    this.personalDataService.closeAndRemove$.subscribe((d) => {
      if (d) {
        console.log(d);
        this.removeFood(d);
        this.activeBtn();
      }
    });
    this.edit = this.route.snapshot.paramMap.get('edit') === 'true';
    if (this.edit) {
      this.editPersonalPAckage = this.personalDataService.editPersonalPackage;
      const personalPackageEdit = this.editPersonalPAckage;
      if (!personalPackageEdit) {
        this.back();
      } else {
        this.packageTitle = personalPackageEdit.title;
        this.selectdFoods = personalPackageEdit.foods.map(
          (v) => [v.food as FoodModel, v.amount] as [FoodModel, number]
        );
      }
    }
    this.calculateFoodAmount();
    this.activeBtn();
  }

  ngOnInit() {}
  back() {
    this.planService.goBack();
  }
  showSearch() {
    this.displaySearch = true;
    setTimeout(() => {
      this.show = true;
    }, 650);
  }
  closeSearch() {
    this.show = false;

    setTimeout(() => {
      this.displaySearch = false;
    }, 650);
  }
  activeBtn() {
    if (this.packageTitle !== '' && this.selectdFoods.length > 0) {
      this.ready = true;
    } else {
      this.ready = false;
    }
  }

  getFoodUnit(food: FoodModel) {
    let unit;
    if (
      food.primaryFoodUnit === '' ||
      food.primaryFoodUnit === '5e1c595d883a966e03fb4530'
    ) {
      unit = 'گرم';
    }
    food.foodUnitRatioArray.forEach((r) => {
      if (r.unitId._id === food.primaryFoodUnit) {
        unit = r.unitId.name;
      }
    });
    return unit;
  }
  calculateFoodAmount() {
    this.foodFactsAmount[0] = parseInt(
      this.calorieCalculator
        .calculatePersonalPackageFoods(this.selectdFoods)
        .toFixed(0)
    );

    this.foodFactsAmount[1] = parseInt(
      this.selectdFoods
        .reduce((p, c) => c[0].foodFact.proteinAmount + p, 0)
        .toFixed(0)
    );

    this.foodFactsAmount[2] = parseInt(
      this.selectdFoods
        .reduce(
          (p, c) =>
            c[0].foodFact.carbohydrateAmount === -1
              ? 0
              : c[0].foodFact.carbohydrateAmount + p,
          0
        )
        .toFixed(0)
    );
    this.foodFactsAmount[3] = parseInt(
      this.selectdFoods
        .reduce(
          (p, c) =>
            c[0].foodFact.fatAmount === -1 ? 0 : c[0].foodFact.fatAmount + p,
          0
        )
        .toFixed(0)
    );
    this.foodFactsAmount[4] = parseInt(
      this.selectdFoods
        .reduce(
          (p, c) =>
            c[0].foodFact.sugarAmount === -1
              ? 0
              : c[0].foodFact.sugarAmount + p,
          0
        )
        .toFixed(0)
    );
    this.foodFactsAmount[5] = parseInt(
      this.selectdFoods
        .reduce(
          (p, c) =>
            c[0].foodFact.fiberAmount === -1
              ? 0
              : c[0].foodFact.fiberAmount + p,
          0
        )
        .toFixed(0)
    );
    this.foodFactsAmount[6] = parseInt(
      this.selectdFoods
        .reduce(
          (p, c) =>
            c[0].foodFact.sodiumAmount === -1
              ? 0
              : c[0].foodFact.sodiumAmount + p,
          0
        )
        .toFixed(0)
    );
    this.foodFactsAmount[7] = parseInt(
      this.selectdFoods
        .reduce(
          (p, c) =>
            c[0].foodFact.potassiumAmount === -1
              ? 0
              : c[0].foodFact.potassiumAmount + p,
          0
        )
        .toFixed(0)
    );
    this.foodFactsAmount[8] = parseInt(
      this.selectdFoods
        .reduce(
          (p, c) =>
            c[0].foodFact.calciumAmount === -1
              ? 0
              : c[0].foodFact.calciumAmount + p,
          0
        )
        .toFixed(0)
    );
    this.foodFactsAmount[9] = parseInt(
      this.selectdFoods
        .reduce(
          (p, c) =>
            c[0].foodFact.magnesiumAmount === -1
              ? 0
              : c[0].foodFact.magnesiumAmount + p,
          0
        )
        .toFixed(0)
    );
    this.foodFactsAmount[10] = parseInt(
      this.selectdFoods
        .reduce(
          (p, c) =>
            c[0].foodFact.phosphorAmount === -1
              ? 0
              : c[0].foodFact.phosphorAmount + p,
          0
        )
        .toFixed(0)
    );
    this.foodFactsAmount[11] = parseInt(
      this.selectdFoods
        .reduce(
          (p, c) =>
            c[0].foodFact.ironAmount === -1 ? 0 : c[0].foodFact.ironAmount + p,
          0
        )
        .toFixed(0)
    );
    this.foodFactsAmount[12] = parseInt(
      this.selectdFoods
        .reduce(
          (p, c) =>
            c[0].foodFact.saturatedFatAmount === -1
              ? 0
              : c[0].foodFact.saturatedFatAmount + p,
          0
        )
        .toFixed(0)
    );

    this.foodFactsAmount[13] = parseInt(
      this.selectdFoods
        .reduce(
          (p, c) =>
            c[0].foodFact.polyunsaturatedFatAmount === -1
              ? 0
              : c[0].foodFact.polyunsaturatedFatAmount + p,
          0
        )
        .toFixed(0)
    );
    this.foodFactsAmount[14] = parseInt(
      this.selectdFoods
        .reduce(
          (p, c) =>
            c[0].foodFact.monounsaturatedFatAmount === -1
              ? 0
              : c[0].foodFact.monounsaturatedFatAmount + p,
          0
        )
        .toFixed(0)
    );
    this.foodFactsAmount[15] = parseInt(
      this.selectdFoods
        .reduce(
          (p, c) =>
            c[0].foodFact.transFatAmount === -1
              ? 0
              : c[0].foodFact.transFatAmount + p,
          0
        )
        .toFixed(0)
    );
    this.foodFactsAmount[16] = parseInt(
      this.selectdFoods
        .reduce(
          (p, c) =>
            c[0].foodFact.cholesterolAmount === -1
              ? 0
              : c[0].foodFact.cholesterolAmount + p,
          0
        )
        .toFixed(0)
    );
  }
  modifyFood(data: [FoodModel, number]) {
    if (this.selectdFoods.length > 0) {
      const finded = this.selectdFoods.findIndex((v) => {
        return v[0]._id === data[0].id;
      });

      if (finded >= 0) {
        this.selectdFoods[finded] = data;
      } else {
        this.selectdFoods.push(data);
      }
    } else {
      this.selectdFoods.push(data);
    }
  }
  removeFood(id: string) {
    this.selectdFoods = this.selectdFoods.filter((v) => v[0]._id !== id);
    if (this.selectdFoods.length > 0) {
      this.calculateFoodAmount();
    }
  }
  editFood(food: FoodModel, amount: number) {
    this.matBottomSheet.open(AddFoodBottomsheetComponent, {
      panelClass: 'custom-bottomsheet-container',
      data: {
        food,
        amount,
        isEditPeronalPackage: true,
        isEditPeronalPackageEdit: true,
      },
    });
  }
  cancel() {
    this.back();
  }
  delete() {
    this.persoanlService
      .removePersonalPackage(this.editPersonalPAckage._id)
      .then((d) => {
        if (d.isSuccess()) {
          this.snackBarService.showSnackBar('غذای شخصی شما با موفقیت حذف شد');
          this.planService.goBack();
        }
      });
  }
  update() {
    if (this.ready) {
      const foods = this.selectdFoods.map(
        (d) =>
          new PersonalPackageFood(
            d[0]._id,
            parseInt(this.textHelper.replacePersian(d[1].toString())),
            d[0].primaryFoodUnit
          )
      );
      const perosnalPackage = new CreatePersonalPackageParams(
        this.packageTitle,
        foods
      );
      this.persoanlService
        .updatePersonalPackage(this.editPersonalPAckage._id, perosnalPackage)
        .then((d) => {
          if (d.isSuccess()) {
            this.snackBarService.showSnackBar(
              'غذای شخصی شما با موفقیت اپدیت شد'
            );
            this.planService.goBack();
          }
        });
    }
  }
  submit() {
    if (this.ready) {
      const foods = this.selectdFoods.map(
        (d) =>
          new PersonalPackageFood(
            d[0]._id,
            parseInt(this.textHelper.replacePersian(d[1].toString())),
            d[0].primaryFoodUnit
          )
      );
      const perosnalPackage = new CreatePersonalPackageParams(
        this.packageTitle,
        foods
      );
      this.persoanlService.createPersonalPackage(perosnalPackage).then((d) => {
        if (d.isSuccess()) {
          this.snackBarService.showSnackBar('غذای شخصی شما با موفقیت ساخته شد');
          this.planService.goBack();
        }
      });
    }
  }
}
